// extracted by mini-css-extract-plugin
export var ctaBtn = "VideoSection-module--ctaBtn--dc221";
export var infoCta = "VideoSection-module--infoCta--b2ba0";
export var title = "VideoSection-module--title--9ccde";
export var video = "VideoSection-module--video--35700";
export var videoWrapper = "VideoSection-module--videoWrapper--dac7b";
export var wrapper = "VideoSection-module--wrapper--66b9c";